import { render, staticRenderFns } from "./ShareFileDialog.vue?vue&type=template&id=68cf81d6&scoped=true&"
import script from "./ShareFileDialog.vue?vue&type=script&lang=js&"
export * from "./ShareFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareFileDialog.vue?vue&type=style&index=0&id=68cf81d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf81d6",
  null
  
)

export default component.exports